import React from 'react';
import { Form } from "semantic-ui-react";
import { useFormik } from 'formik';
import { PaymentCategory } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { initialValues, validationSchema } from "./PaymentCategoryForm.form";

const paymentCategoryController = new PaymentCategory();

export function PaymentCategoryForm(props) {

  const { onClose, onReload, paymentCategory } = props;
  const { accessToken } = useAuth();

  const formik = useFormik({
    initialValues: initialValues(paymentCategory),
    validationSchema: validationSchema(),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        const data = {
          name: formValue.name,
        };

        if (paymentCategory) {
          await paymentCategoryController.updatePaymentCategory(accessToken, paymentCategory.id, data);
        } else {
          data.status = true;
          await paymentCategoryController.createPaymentCategory(accessToken, data);
        }
        onReload();
        onClose();
      } catch (error) {
        console.error(error);
      }
    },
  });

  return (
    <Form onSubmit={formik.handleSubmit}>
      <Form.Input
        name="name"
        label="Nombre de categoría de pago"
        onChange={formik.handleChange}
        value={formik.values.name}
        error={formik.errors.name}
      />
      <Form.Button type="submit" primary fluid loading={formik.isSubmitting}>
        {paymentCategory ? "Actualizar categoría de pago" : "Crear categoría de pago"}
      </Form.Button>
    </Form>
  )
}
